import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SRCPImage from "../../assets/Cocopeatwash.png"; // Placeholder image
import { Helmet } from "react-helmet";

const ProductDetail = () => {
  const { state } = useLocation();
  const { product } = state || {}; // Get product data passed via state

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top of the page when the component mounts
  }, []);

  // Nutrient Table Data
  const tableData = [
    { parameter: "Lignin", value: "4.80%" },
    { parameter: "Cellulose", value: "10.10%" },
    { parameter: "Carbon", value: "24.00%" },
    { parameter: "Nitrogen", value: "1.24%" },
    { parameter: "Phosphorous", value: "0.06%" },
    { parameter: "Potassium", value: "1.20%" },
    { parameter: "Calcium", value: "0.50%" },
    { parameter: "Magnesium", value: "0.48%" },
    { parameter: "Iron (ppm)", value: "0.09" },
    { parameter: "Manganese (ppm)", value: "25.00" },
    { parameter: "Zinc (ppm)", value: "15.80" },
    { parameter: "Copper (ppm)", value: "6.20" },
    { parameter: "C:N Ratio", value: "24:1" },
  ];

  // Additional Product Information
  const additionalInfo = {
    EC: "0.4%",
    WetExpansion: "Suitable for seed germination",
    Fiber: "10%",
    Sand: "Nil",
    NPK: "Checked",
    Age: "6 months aged material",
  };

  if (!product) return <div>Product Not Found</div>;

  return (
    <div className="container mx-auto my-10 p-4 pt-16 bg-gray-50 shadow-lg rounded-lg">
      <Helmet>
        <title>
          {product?.name || "Tirumala Cocopeat - High-Quality Coir Products"}
        </title>
        <meta
          name="description"
          content={`Buy ${
            product?.name || "Cocopeat"
          } online from Tirumala Cocopeat. Best quality coir products for gardening, seed germination, and sustainable farming. ${
            additionalInfo.Age
          } for maximum effectiveness.`}
        />
        <meta
          name="keywords"
          content="Tirumala Cocopeat, Cocopeat Blocks, Coir Pith, Cocopeat Bricks, Organic Gardening, Seed Germination, Best Cocopeat, Bulk Cocopeat Suppliers, Coir Products"
        />
        <meta
          property="og:title"
          content={product?.name || "Tirumala Cocopeat"}
        />
        <meta
          property="og:description"
          content="Premium quality Cocopeat for gardening and hydroponics. High water retention, organic & sustainable."
        />
        <meta property="og:image" content={product?.imgSrc || SRCPImage} />
        <meta property="og:type" content="product" />
        <meta
          property="og:url"
          content={`https://tirumalacocopeat.vercel.app${product?.path}`}
        />
      </Helmet>

      {/* Product Image */}
      <img
        src={product.imgSrc || SRCPImage}
        alt={`Buy ${
          product.name || "Tirumala Cocopeat"
        } Online - Best Quality Coir Products in India`}
        loading="lazy"
        className="w-64 mx-auto mb-5 rounded-md shadow-md"
      />

      {/* Product Title */}
      <h1 className="text-3xl text-center font-extrabold text-gray-700 mb-4">
        {product.name || "Buy Tirumala Cocopeat | Best Coir Products in India"}
      </h1>

      <p className="text-center text-green-600 text-lg font-semibold mb-2">
        Price: {product.price || "₹ 95"}{" "}
        <span className="line-through text-gray-400">
          {product.originalPrice || "₹ 120"}
        </span>
      </p>

      {/* Additional Information Passage */}
      <div className="mt-8 bg-white p-6 rounded-md shadow">
        <h2 className="text-xl font-bold mb-4 text-gray-700">
          Product Highlights
        </h2>
        <p className="text-gray-600 leading-relaxed">
          This premium Tirumala Cocopeat is an excellent growing medium for seed
          germination and gardening needs. It features an Electrical
          Conductivity (EC) of {additionalInfo.EC}, making it suitable for
          sensitive plants. Its Wet Expansion ensures{" "}
          {additionalInfo.WetExpansion}, providing ideal conditions for plant
          growth. The cocopeat contains {additionalInfo.Fiber} fiber content,
          and sand content, ensuring purity. The NPK levels have been thoroughly{" "}
          {additionalInfo.NPK}, and the material is {additionalInfo.Age} for
          maximum effectiveness.
        </p>
      </div>

      {/* Table Data */}
      <div className="mt-10">
        <h2 className="text-xl font-bold mb-4 text-gray-700">
          Nutrient Composition
        </h2>
        <table className="w-full border-collapse border border-gray-200 shadow-md rounded-md">
          <thead>
            <tr className="bg-green-100 text-gray-700">
              <th className="border p-2 text-left">Parameter</th>
              <th className="border p-2 text-left">Value</th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((row, index) => (
              <tr key={index} className="hover:bg-gray-50 transition-all">
                <td className="border p-2 text-gray-600">{row.parameter}</td>
                <td className="border p-2 text-gray-600">{row.value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProductDetail;
